import { render, staticRenderFns } from "./DecisionsList.vue?vue&type=template&id=178aa748"
import script from "./DecisionsList.vue?vue&type=script&lang=js"
export * from "./DecisionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports